<template>
  <div
    class="free-delivery-container"
    :class="{ 'has-free-delivery': subtractFreeShipping <= 0 }"
  >
    <div class="image-container">
      <img :src="imageUrl" alt="Free delivery" />
    </div>
    <div class="text-container">
      <h3
        v-if="subtractFreeShipping > 0"
        v-html="
          $t('Free delivery', { price: formattedPrice(subtractFreeShipping) })
        "
      ></h3>
      <h3 v-else v-html="$t('Has free delivery')"></h3>
    </div>
  </div>
</template>
<script>
import { url } from "../../../../helpers";
import { mapGetters } from "vuex";
import useCart from "../../../views/cart/useCart";

export default {
  methods: {
    url,
  },
  watch:{

  },
  computed: {
    ...mapGetters({
      loader: "loader/getLoader",
      freeShippingLimit: "cart/getFreeShippingLimit",
    }),
    subtractFreeShipping() {
      const subtract = this.freeShippingLimit - this.productPrice

      this.setHasFreeShipping(subtract <= 0);

      return subtract;
    },
    imageUrl() {
      return this.hasFreeShipping
        ? url("/img/cart/white-free-delivery.png")
        : url("/img/cart/free-delivery.png");
    },
  },
  setup() {
    const { formattedPrice, productPrice, setHasFreeShipping } =
      useCart();

    return {
      formattedPrice,
      productPrice,
      setHasFreeShipping,
    };
  },
};
</script>
